import { styled } from '@mui/material/styles'
import { useCallback } from 'react'
import { IconButton, Typography } from '@mui/material'
import { LIMITS } from '@weblite/permission'
// import { WVerificationIllustrationIcon } from '@weblite/icons'
import { EditOutlinedIcon } from '$common/icons'
import { PrimaryButton } from '$common/buttons/primary-button'
import { VerificationCodeInput } from '$common/verification-code-input'
import { Alert } from '$common/input/alert'
import { VerificationSession } from '$logic/auth'
import { closeAuthVerify, goToAuthSignin } from '$logic/router'
import { formatDuration } from '$func/time'
import { t } from '$i18n'
import { toHumanReadablePhone } from '$func/phone'
import { IS_IOS } from '$helper/functions/environmentInfo'
import { toFormattedPersianNumber } from '$helper/functions/text'
import { useVerifyPhoneForm } from '$comp/verification/use-verify-phone-form'

const OTPForm = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`

export function Verification({ phone, sessionId }: VerificationSession) {
  const {
    handleCodeChange,
    handleResendCode,
    resendMaxed,
    remainingMillis,
    alertText,
    loading,
  } = useVerifyPhoneForm({
    phone,
    sessionId,
    onCloseVerification: closeAuthVerify,
  })

  const handleGoBack = useCallback(async () => {
    await goToAuthSignin()
  }, [])

  // TODO get default value of input from prop
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        padding: '48px 24px 24px',
        height: '100%',
        alignItems: 'center',
      }}
    >
      {/* <WVerificationIllustrationIcon
        sx={{
          color: 'secondary700',
          width: '100px',
          height: '100px',
          marginBottom: '4px',
        }}
      /> */}
      <img
        src="/assets/icons/icon.svg"
        style={{ maxHeight: '88px', marginBottom: '10px' }}
        alt="Bonyad shafee Logo"
      />
      <Typography color="secondary700" variant="subtitle1" mb="12px">
        {t('signin.verification.description')}
      </Typography>
      <div
        style={{ display: 'flex', alignItems: 'center', marginBottom: '32px' }}
      >
        <IconButton onClick={handleGoBack}>
          <EditOutlinedIcon sx={{ color: 'primary500' }} />
        </IconButton>
        <Typography color="neutral800" variant="subtitle1" dir="ltr">
          {toHumanReadablePhone(toFormattedPersianNumber(phone))}
        </Typography>
      </div>
      <OTPForm>
        <VerificationCodeInput
          timeout={LIMITS.verificationCode.resendInSeconds * 1000}
          resendMaxed={resendMaxed}
          numFields={LIMITS.verificationCode.length}
          onChange={handleCodeChange}
          hasError={Boolean(alertText)}
          autoComplete
        />
        <Alert
          variant="error"
          text={alertText}
          sxStyle={{
            display: alertText ? 'static' : 'none',
          }}
        />
      </OTPForm>
      <PrimaryButton
        loading={loading}
        disabled={resendMaxed || remainingMillis > 0 || loading}
        // sx={{ marginTop:'auto'  }}
        sx={{ marginTop: IS_IOS ? 'auto' : '24px' }}
        fullWidth
        text={
          resendMaxed || remainingMillis <= 0
            ? t('signin.verification.resendCode')
            : t('signin.verification.validTillXMore', {
                x: formatDuration(remainingMillis),
              })
        }
        onClick={handleResendCode}
      />
    </div>
  )
}
